import { apiSlice } from "../apiSlice";
export const autocompApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAutocomplete: builder.mutation({
      query: (parameters) => ({
        url: `/${parameters.MODURLXX}/${parameters.PRODURLX}/${parameters.endpoint}/${parameters.filter}`,
        method: "GET",
        params: {},
        headers: { Modulecima: parameters.MODURLXX.toLowerCase() },
      }),
    }),
    getAutocompleteWithParams: builder.mutation({
      query: (parameters) => ({
        url: `/${parameters.MODURLXX}/${parameters.PRODURLX}/${parameters.endpoint}`,
        method: "GET",
        //extraParams permite que un autocompletar mande filtros propios sin afectar a los demas
        params: { filter: parameters.filter, ...(parameters.extraParams ?? {}) },
        headers: { Modulecima: parameters.MODURLXX.toLowerCase() },
      }),
    }),
    getAutocompleteWithFilters: builder.mutation({
      query: (parameters) => ({
        url: `/${parameters.MODURLXX}/${parameters.PRODURLX}/${parameters.endpoint}`,
        method: "GET",
        params: { filters: parameters.filters },
        headers: { Modulecima: parameters.MODURLXX.toLowerCase() },
      }),
    }),
  }),
});

export const {
  useGetAutocompleteMutation,
  useGetAutocompleteWithParamsMutation,
  useGetAutocompleteWithFiltersMutation,
} = autocompApiSlice;
